"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
function disableAttendeeScreenShare(source) {
  return function (dispatch) {
    var action = {
      type: _types.BROADCAST_STOP_PRESENTER_SCREEN_SHARE,
      payload: {
        attendeeId: source.value.replace('#content', '')
      }
    };
    dispatch(action);
  };
}
var _default = exports["default"] = disableAttendeeScreenShare;